/* GoRetrofits scroll-reveal — cards rise a little and fade in as they scroll
   into view, cascading quickly when several enter together. Reveals once.

   An IntersectionObserver reports cards as they enter the viewport (it works
   whichever element Horizon scrolls), so nothing runs per frame. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var STAGGER = 60; // ms between cards of one group entering together
  var UNSTICK_DELAY = 4000; // ms: reveal cards already on screen, whatever happens

  var armed = [];

  var observer = new IntersectionObserver(
    function (entries) {
      // cascade per group: cards of the same group entering in one batch
      var bursts = new Map();
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var group = el.__grGroup;
        var index = bursts.get(group) || 0;
        bursts.set(group, index + 1);
        show(el, index);
      });
    },
    // reveal when a card's top passes ~88% of the viewport height
    { rootMargin: '0px 0px -12% 0px', threshold: 0 }
  );

  function show(el, burstIndex) {
    if (el.__grShown) return;
    el.__grShown = true;
    observer.unobserve(el);
    el.style.animationDelay = (burstIndex || 0) * STAGGER + 'ms';
    el.classList.add('is-visible');
  }

  function armGroup(items, group) {
    items.forEach(function (el) {
      if (el.__grArmed) return;
      el.__grArmed = true;
      el.__grGroup = group;
      el.classList.add('gr-reveal-armed');
      armed.push(el);
      observer.observe(el);
    });
  }

  function collect() {
    document.querySelectorAll('[data-gr-reveal-group]').forEach(function (group) {
      var items = Array.prototype.slice.call(group.querySelectorAll('[data-gr-reveal]'));
      // No explicitly tagged children? reveal the group's direct element children.
      if (!items.length) {
        items = Array.prototype.slice.call(group.children).filter(function (el) {
          return el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE' && el.tagName !== 'LINK';
        });
      }
      armGroup(items, group);
    });
    document.querySelectorAll('[data-testid="collection-list"] .resource-list').forEach(function (grid) {
      armGroup(Array.prototype.slice.call(grid.querySelectorAll('.resource-list__item')), grid);
    });
    // Collection-list header lines (COLLECTION LIST / by GORETROFITS)
    document.querySelectorAll('[data-testid="collection-list"] .section-resource-list__content').forEach(function (head) {
      armGroup(Array.prototype.slice.call(head.querySelectorAll('.text-block')), head);
    });

    // Collection-page product grid — arm the cards present at first load only,
    // so re-filtering / re-sorting (which swaps the grid) doesn't replay it.
    if (!window.__grProductGridArmed) {
      var productGrid = document.querySelector('[data-template^="collection"] .product-grid--grid');
      if (productGrid) {
        window.__grProductGridArmed = true;
        armGroup(Array.prototype.slice.call(productGrid.querySelectorAll('.product-grid__item')), productGrid);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collect, { once: true });
  } else {
    collect();
  }

  window.addEventListener('load', collect);
  document.addEventListener('shopify:section:load', collect);

  // Failsafe: only un-stick cards already in or above the viewport.
  setTimeout(function () {
    var vh = window.innerHeight;
    armed.forEach(function (el) {
      if (!el.__grShown && el.getBoundingClientRect().top < vh) show(el, 0);
    });
  }, UNSTICK_DELAY);
})();
